import React from 'react';

const PopupInfo = ({ mapInfo }) => {

    return (
      <>
        <pre>
          <span className="pre-bold">Tipo de disposición final: </span>{mapInfo.info.tipo__disp} <br />
          <span className="pre-bold">Latitud (este): </span>{mapInfo.info.x} <br />
          <span className="pre-bold">Longitud (norte): </span>{mapInfo.info.y} <br />
          <span className="pre-bold">Sector de ubicación: </span>{mapInfo.info.sector} <br />
          <span className="pre-bold">Parroquia de Ubicación: </span>{mapInfo.info.parroquia} <br />
          <span className="pre-bold">Cantón: </span>{mapInfo.info.canton_nom} <br />
          <span className="pre-bold">Cantones de los que recibe residuos: </span>{mapInfo.info.canton_nom} <br />
        </pre>
      </>
    );
  }  

export default PopupInfo;
